module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  }), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('LanguageSwitcher', {
    attrs: {
      "type": "dropdown",
      "show-title": false
    },
    on: {
      "pickedlanguage": _vm.reMount
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "animate-filter"
    }
  }, [(_vm.people[_vm.currentIndex]) ? _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.enter-details', {
    name: ''
  })) + " " + _vm._s(_vm.people[_vm.currentIndex].name))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.people), function(person, index) {
    return (person.guideCompleted) ? _c('div', {
      class: {
        person: true, opened: (_vm.currentIndex === index), completed: (person.guideFullyCompleted && _vm.currentIndex !== index)
      }
    }, [_c('div', {
      staticClass: "blue-bar",
      on: {
        "click": function($event) {
          return _vm.setActive(_vm.currentIndex !== index ? index : -1)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(person.name) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "package max-tablet"
    }, [(person.type === 'package') ? _c('b', [_vm._v(_vm._s(_vm.$t('skirental.package', {
      package: ''
    })) + " " + _vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ":")]) : _vm._e(), _vm._v(" "), (person.type === 'single') ? _c('b', [_vm._v(_vm._s(_vm.categories[person.subCategory] || _vm.categories[person.category]) + ":")]) : _vm._e(), _vm._v(" "), (person.type !== 'single' && person.type !== 'package') ? _c('b', [(person.onlySkipass) ? _c('b', [_vm._v(_vm._s(_vm.$t('general.skipass')) + ":")]) : _vm._e()]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.ages[person.age]) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "level max-tablet"
    }, [(person.searchPackage === 'beginner') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.beginner')))]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'intermediate') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.average')))]) : _vm._e(), _vm._v(" "), (person.searchPackage === 'advanced') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.level.advanced')))]) : _vm._e()]), _vm._v(" "), (!_vm.hasClosedDaysInRange(person)) ? _c('span', {
      staticClass: "date max-tablet"
    }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.date')) + ":")]), _vm._v(" " + _vm._s(_vm._f("dateRange")(_vm.dateRange(person), 'long')))])]) : _vm._e(), _vm._v(" "), (_vm.hasClosedDaysInRange(person)) ? _c('span', {
      staticClass: "date max-tablet"
    }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.date')) + ":")]), _vm._v(" " + _vm._s(person.days) + " " + _vm._s(_vm.$t('general.days')))])]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === index) ? _c('span', {
      staticClass: "change max-tablet"
    }, [_c('button', {
      staticClass: "small white tight",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(index)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.5
      }
    })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.currentIndex !== index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.show')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-green",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-down-blue",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentIndex === index) ? _c('span', {
      staticClass: "show-or-close"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('general.close')) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [(person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-up-white",
        "scale": 1.9
      }
    }) : _vm._e(), _vm._v(" "), (!person.guideFullyCompleted) ? _c('icon', {
      attrs: {
        "name": "chevron-up-white",
        "scale": 1.9
      }
    }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "animate-filter"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.currentIndex === index)),
        expression: "(currentIndex === index)"
      }]
    }, [_c('div', {
      staticClass: "inner-width"
    }, [_c('div', {
      staticClass: "flex sizes-list"
    }, [(_vm.required(index, 'lengthCm')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.measurements.length-your')) + " (" + _vm._s(_vm.$t('skirental.measurements.centimeter-short')) + ")"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": true,
        "options": _vm.lengthOptionsCalculated(person),
        "valuebinder": person.lengthCm,
        "label": _vm.$t('skirental.example-centimeter'),
        "validated": person.lengthCm && !_vm.showError(index, 'lengthCm', true),
        "error": _vm.showError(index, 'lengthCm', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "lengthCm", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'lengthCm')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'weight')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.measurements.weight')) + " (" + _vm._s(_vm.$t('skirental.measurements.kilogram-short')) + ")"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": true,
        "options": _vm.lengthOptions[person.age].weightOptions,
        "valuebinder": person.weight,
        "label": _vm.$t('skirental.example-kilogram'),
        "validated": person.weight && !_vm.showError(index, 'weight', true),
        "error": _vm.showError(index, 'weight', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "weight", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'weight')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'shoeSize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.measurements.shoesize'))), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v(" "), _c('button', {
      staticClass: "small white border tight",
      on: {
        "click": function($event) {
          return _vm.openModal(['SkiRentalFoot', {
            index: index
          }])
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 1
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.info-short')))], 1)]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.shoesizeOptionsCalculated(person),
        "valuebinder": person.shoeSize,
        "label": _vm.$t('general.pick'),
        "validated": person.shoeSize && !_vm.showError(index, 'shoeSize', true),
        "error": _vm.showError(index, 'shoeSize', true),
        "show-label-subtitle": true
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "shoeSize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'shoeSize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'jacketsize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Jackstorlek (unisex)"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.productSizes(person, '_jacketsizes'),
        "valuebinder": person.jacketsize,
        "label": 'Jackstorlek',
        "validated": person.jacketsize && !_vm.showError(index, 'jacketsize', true),
        "error": _vm.showError(index, 'jacketsize', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "jacketsize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'jacketsize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'pantsize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Byxstorlek (unisex)"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.productSizes(person, '_pantsizes'),
        "valuebinder": person.pantsize,
        "label": 'Byxstorlek',
        "validated": person.pantsize && !_vm.showError(index, 'pantsize', true),
        "error": _vm.showError(index, 'pantsize', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "pantsize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'pantsize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.required(index, 'clothsize')) ? _c('div', {
      staticClass: "control"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Klädstorlek"), _c('span', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
      attrs: {
        "combo": false,
        "options": _vm.clothsizeOptionsCalculated(person),
        "valuebinder": person.clothsize,
        "label": 'Klädstorlek',
        "validated": person.clothsize && !_vm.showError(index, 'clothsize', true),
        "error": _vm.showError(index, 'clothsize', true),
        "show-label-subtitle": false
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(person, "clothsize", $event)
        },
        "touch": function($event) {
          return _vm.touch(index, 'clothsize')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [(_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'kungsberget' || _vm.SITE_CONFIG.site === 'storstenshojden') ? _c('div', [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.title')))]), _vm._v(" "), _vm._l((person.wishes), function(wish, key) {
      return (wish && key !== 'hasWishes') ? _c('FilterListItem', {
        key: key,
        attrs: {
          "label": _vm.wishesLabels[key],
          "value": key
        },
        on: {
          "click": function($event) {
            return _vm.removeWish(index, key)
          }
        }
      }) : _vm._e()
    }), _vm._v(" "), (!person.wishes.hasWishes) ? _c('button', {
      staticClass: "border-bottom underlined small-text wishes-bt",
      on: {
        "click": _vm.openWishes
      }
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.add')))]) : _vm._e(), _vm._v(" "), (person.wishes.hasWishes) ? _c('button', {
      staticClass: "border-bottom underlined small-text wishes-bt",
      on: {
        "click": _vm.openWishes
      }
    }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.change')))]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showError(index, 'lengthCm', true)),
        expression: "showError(index, 'lengthCm', true)"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.showError(index, 'lengthCm')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showError(index, 'weight', true) && !_vm.showError(index, 'lengthCm', true)),
        expression: "showError(index, 'weight', true) && !showError(index, 'lengthCm', true)"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.showError(index, 'weight')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showError(index, 'shoeSize', true) && !_vm.showError(index, 'lengthCm', true) && !_vm.showError(index, 'weight', true)),
        expression: "showError(index, 'shoeSize', true) && !showError(index, 'lengthCm', true) && !showError(index, 'weight', true)"
      }],
      staticClass: "error-message"
    }, [_vm._v(_vm._s(_vm.showError(index, 'shoeSize')))])]), _vm._v(" "), _c('div', {
      staticClass: "--inner-width"
    }, [_c('div', {
      staticClass: "addons inner-width"
    }, [(!person.onlySkipass && person.possibleAddons && person.possibleAddons.length) ? _c('h4', [_vm._v(_vm._s(_vm.$t('skirental.rent-addon')))]) : _vm._e(), _vm._v(" "), (!person.onlySkipass) ? _c('div', {
      staticClass: "addon-list"
    }, _vm._l((person.possibleAddons), function(product) {
      return (_vm.showProduct(index, product)) ? _c('div', {
        class: {
          active: _vm.productIsAdded(index, product)
        }
      }, [_c('div', {
        class: {
          image: true, 'default-image': true, 'has-description': !!product.description
        },
        style: (product.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + product.image + ')' : 'background-size:cover;'),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.infoPopup(product)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "info-blue",
          "scale": 0.9
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('h4', [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s((person.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : person.days) + " " + _vm._s((person.priceType === 'night' ?
        (_vm.SITE_CONFIG.site === 'vallasen' ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
          hours: _vm.SITE_CONFIG.rental.night_hours
        })) :
        (person.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
      )) + "\n              ")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(product['price_' + person.days + (person.priceType === 'night' ? '_night' : '')])))]), _vm._v(" "), _c('button', {
        class: {
          small: true,
            green: _vm.productIsAdded(index, product),
            'float-right': true
        },
        on: {
          "click": function($event) {
            return _vm.addAddon(index, product)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.productIsAdded(index, product) ? _vm.$t('general.picked') : _vm.$t('general.pick')) + "\n              ")])])]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), (!person.onlySkipass && person.possibleBuy && person.possibleBuy.length) ? _c('h4', [_vm._v(_vm._s(_vm.$t('skirental.buy-addon')))]) : _vm._e(), _vm._v(" "), (!person.onlySkipass) ? _c('div', {
      staticClass: "addon-list"
    }, _vm._l((person.possibleBuy), function(product) {
      return (_vm.showProduct(index, product)) ? _c('div', {
        class: {
          active: _vm.productIsAdded(index, product)
        }
      }, [_c('div', {
        class: {
          image: true, 'default-image': true, 'has-description': !!product.description
        },
        style: (product.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + product.image + ')' : 'background-size:cover;'),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.infoPopup(product)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "info-blue",
          "scale": 0.9
        }
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('h4', [_vm._v(_vm._s(product.name))]), _vm._v(" "), ((product.code || '').match(/liftkort|skipass/ig)) ? _c('p', [_vm._v("\n                " + _vm._s((person.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : person.days) + " " + _vm._s((person.priceType === 'night' ?
        (_vm.SITE_CONFIG.site === 'vallasen' ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
          hours: _vm.SITE_CONFIG.rental.night_hours
        })) :
        (person.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
      )) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(product['price_' + person.days + (person.priceType === 'night' ? '_night' : '')])))]), _vm._v(" "), _c('button', {
        class: {
          small: true,
            green: _vm.productIsAdded(index, product),
            'float-right': true
        },
        on: {
          "click": function($event) {
            return _vm.addAddon(index, product)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.productIsAdded(index, product) ? _vm.$t('general.picked') : _vm.$t('general.pick')) + "\n              ")])])]) : _vm._e()
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "products"
    }, [_c('div', {
      staticClass: "heading-products"
    }, [_vm._v(_vm._s(_vm.$t('general.summary')))]), _vm._v(" "), _c('table', [_vm._l((person.products), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), _vm._l((person.addons), function(product, iindex) {
      return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(product.name) + "\n              ")]), _vm._v(" "), (product) ? _c('td', {
        staticClass: "price"
      }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(product.price)))])]) : _vm._e()])
    }), _vm._v(" "), (_vm.SITE_CONFIG.rental.delivery_fee_active && _vm.hasDelivery && !_vm.parentHasFee) ? _c('tr', {
      staticClass: "delivery-fee-row"
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm.SITE_CONFIG.rental.delivery_fee_name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.SITE_CONFIG.rental.delivery_fee_price)))])])]) : _vm._e(), _vm._v(" "), _c('tr', {
      staticClass: "total"
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm.$t('general.price')) + " " + _vm._s(person.name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "price"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("currency")((
      person.products.reduce(function(a, product) {
        return a + product.price
      }, 0) +
      person.addons.reduce(function(a, product) {
        return a + product.price
      }, 0)
    ))))])])])], 2)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "sum-bar"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('general.total-neutrum')) + ":\n      "), _c('b', [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.sum)) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "center space-3 button-confirm"
  }, [(_vm.nextIndex) ? _c('button', {
    class: {
      disabled: !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-on-to-next-skier')))]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    class: {
      small: true, white: true, border: true, big: true, disabled: !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.addPerson()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.add-skier')))]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('span', {
    staticStyle: {
      "margin-left": "15px",
      "margin-right": "15px"
    }
  }, [_vm._v(" ... " + _vm._s(_vm.$t('general.or')) + " ... ")]) : _vm._e(), _vm._v(" "), (!_vm.nextIndex) ? _c('button', {
    class: {
      disabled: !_vm.validate()
    },
    on: {
      "click": function($event) {
        return _vm.doRental()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.complete-booking')))]) : _vm._e()])], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7a4a576"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiRental/SkiRentalUserOverview.vue
// module id = 1055
// module chunks = 0